export { InvisibleMapTable } from './invisible-map-table.component';
